import { SegmentColorType } from '../types/Game'

export const randomTargetSegmentIndex = (segments: SegmentColorType[], target: SegmentColorType): number => {
    const indexes: number[] = segments.reduce((indexes, color, i) => {
        if (color === target) {
            indexes.push(i)
        }
        return indexes
    }, [] as number[])

    if (!indexes.length) {
        return -1
    }

    return indexes[Math.floor(Math.random() * indexes.length)]
}